import { parseElementFromString } from 'anodum';
import { connectedStore } from '../../store';
import getGlobal from '../selectors/global';
import actions from '../actions';

const changeGlobalContent = (globalId = null, handler = null, affectHistory = false) => {
  if (!globalId || !handler) return false;

  const store = connectedStore.get();
  const state = store.getState();
  const global = getGlobal(state, globalId);

  if (!global || !global.html) return false;

  const globalFragment = parseElementFromString(global.html);

  const affectedHTML = handler(globalFragment);
  if (!affectedHTML) return false;

  const html = affectedHTML.outerHTML;

  if (affectHistory) {
    store.dispatch(actions.setGlobalHTMLAndAffectHistory(globalId, html));
  } else {
    store.dispatch(actions.setGlobalHTML(globalId, html));
  }

  return affectedHTML;
};

export default changeGlobalContent;
